module.exports = __webpack_public_path__ + "static/img/baccarat-guide-03.0c55c89.png";